import { FC } from "react";

interface PopupFieldProps {
  label: string;
  value: string;
}

const PopupField: FC<PopupFieldProps> = ({ label, value }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: 8,
        fontSize: 10,
      }}
    >
      <span
        style={{
          color: "#757575",
          letterSpacing: 1.1,
        }}
      >
        {label}
      </span>
      <span style={{ fontWeight: "bolder", marginTop: 2, fontSize: 13 }}>
        {value}
      </span>
    </div>
  );
};

export default PopupField;
